const HOST = 'https://aftplatform.com/api/v2';
const unwrap = async response => {
  if (!response.ok) {
    throw new Error(`The server responded with ${response.status}`);
  }
  return response.json();
};

// The payload goes on the URL. Null and undefined are dropped rather than sent
// as the strings "null" and "undefined".
const get = async (path, params) => {
  let query = new URLSearchParams(Object.entries(params || {}).filter(([, value]) => value !== null && value !== undefined)).toString();
  let response = await fetch(`${HOST}${path}${query ? `?${query}` : ''}`, {
    headers: {
      Accept: 'application/json'
    },
    method: 'GET'
  });
  return unwrap(response);
};
const post = async (path, body) => {
  let response = await fetch(`${HOST}${path}`, {
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'POST'
  });
  return unwrap(response);
};
const Requests = {
  lookup: async ({
    email_address,
    phone_number
  }) => {
    let result = await get('/support/', {
      email_address: email_address,
      phone_number: phone_number,
      type: 'customer_dealer_lookup'
    });
    return {
      dealership: result.dealership || null
    };
  },
  submit: async payload => {
    let result = await post('/support/', {
      ...payload,
      type: 'new_escalation'
    });
    return {
      reference: result.reference_id || null
    };
  }
};
export default Requests;